/**
 * crypto.randomUUID() is secure-context only, so it is unavailable when the iPad
 * loads the dev server over plain http on the LAN. getRandomValues has no such
 * restriction, so build the id from that and keep a last-resort fallback.
 */
export function newId(): string {
  const bytes = new Uint8Array(16)
  const c = globalThis.crypto
  if (c && typeof c.getRandomValues === 'function') {
    c.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256)
  }
  // RFC 4122 v4 bits
  bytes[6] = (bytes[6]! & 0x0f) | 0x40
  bytes[8] = (bytes[8]! & 0x3f) | 0x80
  const hex: string[] = []
  for (let i = 0; i < bytes.length; i++) hex.push(bytes[i]!.toString(16).padStart(2, '0'))
  return (
    hex.slice(0, 4).join('') +
    '-' + hex.slice(4, 6).join('') +
    '-' + hex.slice(6, 8).join('') +
    '-' + hex.slice(8, 10).join('') +
    '-' + hex.slice(10, 16).join('')
  )
}
